export default __webpack_public_path__ + "static/media/logo.b922a3f4.png";